import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { InputMask } from '@react-input/mask';
import DInput from '../DInput';
function DInputMask(props, ref) {
    return (_jsx(InputMask, Object.assign({ ref: ref, component: DInput }, props)));
}
const ForwardedDInputMask = forwardRef(DInputMask);
ForwardedDInputMask.displayName = 'DInputMask';
export default ForwardedDInputMask;
//# sourceMappingURL=DInputMask.js.map